import Image from 'next/image';

interface IPrivateGroupScreen {
  description: string | React.ReactElement;
}

interface IPrivateGroupHOC extends IPrivateGroupScreen {
  conditionShowPrivateContent: boolean;
}

const LockGroupScreen = ({ description }: IPrivateGroupScreen) => {
  return (
    <div className="mx-auto flex flex-col gap-3 justify-center items-center pt-10 w-[275px] mb-20">
      <div className="col-span-2 flex justify-center">
        <Image
          width={52}
          height={42}
          src={`/img/private-content.png`}
          alt="private-content"
        />
      </div>
      <div>{description}</div>
    </div>
  );
};
const LockGroupContentHOC: React.FC<IPrivateGroupHOC> = ({
  children,
  description,
  conditionShowPrivateContent,
}) => {
  return !conditionShowPrivateContent ? (
    (children as React.ReactElement)
  ) : (
    <LockGroupScreen description={description} />
  );
};

export default LockGroupContentHOC;
